// (function () {
//     'use strict';

//     angular.module("imApp").factory("poPurchPlanningService", ['$ihttp', function ($ihttp) {
//         let service = {
//             getPoPurchPlanning: function (parms) {
//                 return $ihttp.post({
//                     method: 2422,
//                     parameters: parms || {}
//                 });
//             },
//             switchToPurchase: function (mergeObj) {
//                 return $ihttp.post({
//                     method: 2424,
//                     parameters: mergeObj
//                 });
//             }
//         };

//         return service;
//     }]);
// })();
